export default __webpack_public_path__ + "static/publisher_app-3d5615d0261c4115d63b7e17fd05703e.png";